<i18n lang="yaml">
en:
  gitlab_username: GitLab username
  github_username: GitHub username
  required: This field is required
  save: Save
  error_occurred: An error occurred while importing keys
ru:
  gitlab_username: Имя пользователя GitLab
  github_username: Имя пользователя GitHub
  required: Это поле обязательно
  save: Сохранить
  error_occurred: Произошла ошибка при импорте ключей
</i18n>

<script setup lang="ts">
import { Field, Form } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import * as yup from 'yup'
import { onMounted, ref, watch } from 'vue'
import { useMyFetch } from '@/utils'
import { useAlertStore } from '@/store'
import { useRouter } from 'vue-router'
const { t } = useI18n()
const alertStore = useAlertStore()
const router = useRouter()

const props = defineProps({
  provider: {
    type: String,
    required: true
  }
})

async function onSubmit() {
  const { error } = await useMyFetch('profile/keys/import')
    .post({
      username: username.value,
      provider: props.provider
    })
    .json()
  if (error.value) {
    alertStore.error(t('error_occurred'))
  } else {
    await router.push({ name: 'account:keys:list' })
  }
}

const username = ref()
const schema = yup.object({
  username: yup.string().required(t('required'))
})

onMounted(() => {
  document.querySelector<HTMLInputElement>(`[name=username]`)?.focus()
})

watch(
  () => props.provider,
  () => {
    document.querySelector<HTMLInputElement>(`[name=username]`)?.focus()
  }
)
</script>

<template>
  <div class="card-body">
    <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors, isSubmitting }">
      <div class="form-group mb-3">
        <label>{{ t(`${props.provider}_username`) }}</label>
        <div class="input-group">
          <div class="input-group-text">https://{{ provider }}.com</div>
          <Field
            v-model="username"
            name="username"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.username }"
            :validateOnBlur="false"
          />
          <div class="invalid-feedback">{{ errors.username }}</div>
        </div>
      </div>
      <div class="form-group mb-3">
        <button class="btn btn-primary" type="submit">
          <span v-show="isSubmitting" class="spinner-border spinner-border-sm mr-1"></span>
          {{ t('save') }}
        </button>
      </div>
    </Form>
  </div>
</template>
